import React, { useState } from 'react';
import axios from 'axios';
import { TextField, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './ForgotPassword.css';
import { AUTH_APP_VERSION, AUTH_LEGAL_NOTICE } from '../constants/authMeta';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/forgot-password`,
        { email }
      );
      setMessage(res.data.message || 'Check your email for reset instructions.');
    } catch (error) {
      console.error('Error in forgot password:', error);
      setError(error.response?.data?.message || 'Error sending reset email.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-shell">
        <div className="login-left">
          <div className="login-left-inner">
            <img src="/logo_white.png" alt="EXREG" className="login-brand-logo" />
            <Typography className="login-brand-subtitle">
              Hazardous Area Equipment Register & Inspection Platform
            </Typography>

            <ul className="login-highlights">
              <li>Password reset link will be sent to your email</li>
              <li>Use your registered company email address</li>
              <li>Link expires automatically for security</li>
            </ul>

            <div className="login-left-badges">
              <span className="login-badge">Secure</span>
              <span className="login-badge">Account</span>
              <span className="login-badge">Recovery</span>
            </div>
          </div>
        </div>

        <div className="login-right">
          <div className="login-box">
            <Typography className="login-title">Forgot password</Typography>
            <Typography className="login-subtitle">
              Enter your email and we’ll send you reset instructions.
            </Typography>

            <form onSubmit={handleSubmit} className="login-form">
              <TextField
                fullWidth
                label="Email address"
                margin="normal"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />

              {error && (
                <Typography className="login-message error">{error}</Typography>
              )}

              {message && (
                <Typography className="login-message success">{message}</Typography>
              )}

              <Button
                type="submit"
                variant="contained"
                fullWidth
                className="login-primary-btn"
              >
                Send reset instructions
              </Button>

              <Button
                variant="text"
                color="secondary"
                fullWidth
                className="login-forgot-btn"
                onClick={() => navigate('/login')}
              >
                Back to login
              </Button>
            </form>

            <div
              className="login-meta"
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}
            >
              <Typography variant="caption" className="login-version" style={{ textAlign: 'center' }}>
                {AUTH_APP_VERSION}
              </Typography>
              <Typography variant="caption" className="login-legal" style={{ textAlign: 'center' }}>
                {AUTH_LEGAL_NOTICE}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
